import { student } from "../../constants/apiUrl";
import { IHelpMail } from "../../models/common/IHelpMail";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";

export default new (class StudentHelpMail {
    public getFacultyHelpMail = async (): Promise<IApiResponse<IHelpMail>> => {
        try {
            let endPoint = student.STUDENT_FACULTY_HELP_MAIL;
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<IHelpMail>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<IHelpMail>;
            } else {
                throw error;
            }
        }
    };

    public getAdvisorHelpMail = async (): Promise<IApiResponse<IHelpMail>> => {
        try {
            let endPoint = student.STUDENT_ADVISOR_HELP_MAIL;
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<IHelpMail>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<IHelpMail>;
            } else {
                throw error;
            }
        }
    };

    public getAllContactMail = async (): Promise<IApiResponse<IHelpMail>> => {
        try {
            let endPoint = student.STUDENT_ALL_CONTACT_MAIL;
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<IHelpMail>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<IHelpMail>;
            } else {
                throw error;
            }
        }
    };
})();